import React, { useContext } from "react";
import { useLocation } from "react-router-dom";
import { Flex, Layout } from "antd";
import {
  HeaderComp,
  PostDetailComp,
  FooterComp,
  CarouselComp
} from "../../../components";
import { LangContext } from "../../../utils/LanguageProvider";
const { Header, Content, Footer } = Layout

const PostDetail = () => {
  const { lang } = useContext(LangContext);
  const location = useLocation();

  const categoryName = location.pathname.split('/')[3]

  return (
    <>
      <Header>
        <div className="header-container">
          <HeaderComp />
        </div>
      </Header>
      <div className="full-container">
        <Flex vertical style={{ maxWidth: '1400px' }}>
          <Content className="global-content">
            <PostDetailComp slug={`${location.pathname}`} categoryName={categoryName} lang={lang} />
            <CarouselComp page={"blog"} section={"postlist"} type={'posts'} numPosts={9} categoryName={categoryName} buttons={true} lang={lang} />
          </Content>
        </Flex>
      </div>
      <Footer>
        <FooterComp page={categoryName} lang={lang} />
      </Footer>
    </>
  );
}

export default PostDetail